import { isQuotingToolAvailable } from 'modules/common/permissions';

import DashboardDetailsPage from './dashboardEntry';
import { initAdvancedAnalytics, initExplorePage } from './data/sagas';
import ExplorePage from './exploreEntry';

export default [
  {
    component: DashboardDetailsPage,
    exact: true,
    path: '/analytics/dashboards',
    helpId: 'analytics_dashboard',
    permissions: [isQuotingToolAvailable],
    saga: initAdvancedAnalytics,
  },
  {
    component: ExplorePage,
    path: '/analytics/explore/',
    helpId: 'analytics_explore',
    exact: true,
    permissions: [isQuotingToolAvailable],
    saga: initExplorePage,
  },
  {
    component: ExplorePage,
    path: '/analytics/explore/:queryId',
    helpId: 'analytics_explore',
    exact: true,
    permissions: [isQuotingToolAvailable],
    saga: initExplorePage,
  },
];
